/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_REQUEST_API = "DO_REQUEST_API";
export const DO_LANDING = "DO_LANDING";
export const DO_LANDING_SUCCESS = "DO_LANDING_SUCCESS";
export const DO_LANDING_ERROR = "DO_LANDING_ERROR";
export const DO_PASO1 = "DO_PASO1";
export const DO_GRACIAS = "DO_GRACIAS";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_ENVIAR_DATOS = "DO_ENVIAR_DATOS";
export const DO_ADOBE_APPSTARTED = "DO_ADOBE_APPSTARTED";
